<template>
  <v-container style="position:absolute;" fluid class="pa-0">
    <v-toolbar dense :color="(activeTour == null) ? 'transparent' : 'rgba(0,0,0,0.6)'" flat class="pa-0">
      <v-btn dark ripple="" @click="SetNavigationBar(!navigationBar)" class="ma-0" :x-large="!$vuetify.breakpoint.smAndDown" height="100%" tile :color="(activeTour == null) ? 'rgba(0,0,0,0.7)' : 'transparent'" :text="(activeTour != null)">
          <v-icon left color="#69d6e0">
            mdi-map-marker
          </v-icon>
          <span style="color:#69d6e0;" >SHOW MAP</span>
      </v-btn>
      <v-row v-if="activeTour != null">
        <v-col cols="12" class="text-center font-weight-bold" style="color:white;">
          <span v-if="!$vuetify.breakpoint.smAndDown" style="letter-spacing: 4px;" class="headline text-uppercase">{{activeTour.name}}</span>
          <span v-else style="letter-spacing: 4px;" class="subtitle-2 text-uppercase">{{activeTour.name}}</span>
        </v-col>
      </v-row>
      <v-spacer v-else/>

      <v-btn
        v-if="!kioskMode"
        icon
        width="48px"
        height="48px"
        href="https://www.facebook.com/museumofworldathletics/"
        class="mr-1 pa-1"
        target="_blank"
        rel="noopener noreferrer"
      >
        <v-img
          icon
          width="44px"
          height="44px"
          alt="facebook"
          src="assets/f_logo_RGB-Blue_58.png"
        />
      </v-btn>

      <v-toolbar-items  v-if="activeTour == null" >
          <v-btn :x-small="$vuetify.breakpoint.xsOnly" :small="!$vuetify.breakpoint.xsOnly" dark class="mr-0 pa-0" height="48px" width="20px" @click="OnTapAudio()">
            <v-icon v-if="isPlayingAudio">
              mdi-volume-high
            </v-icon>
            <v-icon v-else>
              mdi-volume-off
            </v-icon>
          </v-btn>
          <v-btn :x-small="$vuetify.breakpoint.xsOnly" :small="!$vuetify.breakpoint.xsOnly" dark class="mr-0 pa-0" height="48px" width="20px" @click="helpGuideDialog = true">
            <v-icon>
              mdi-help-circle
            </v-icon>
          </v-btn>
        
         <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="white"
                dark
                v-bind="attrs"
                v-on="on"
                :x-small="$vuetify.breakpoint.xsOnly" :small="!$vuetify.breakpoint.xsOnly" class="mr-0 pa-0 pl-1 pr-1" height="48px"  
              >
                <v-avatar size="24" tile>
                  <v-img
                  :transition="false"
                  :eager="false"
                  :src="iconForLcl"
                  >
                  </v-img>
                </v-avatar>
                <v-icon color="black">
                  mdi-chevron-down
                </v-icon>
              </v-btn>
            </template>
            <v-card dark hover  v-for="(lng, index) in languages"
              :key="index" class="pa-3" tile
              @click="SetCurrentLanguage(lng.key)"
              >
              <v-avatar size="24" tile>
                <v-img
                :transition="false"
                :eager="false"
                :src="lng.icon"
                >
                </v-img>
              </v-avatar>
              
            </v-card>
          </v-menu>

          <v-btn :x-small="$vuetify.breakpoint.xsOnly" :small="!$vuetify.breakpoint.xsOnly" dark class="mr-0 pa-0" height="48px" tile @click="OnTapHome()">
            <v-icon>
              mdi-home
            </v-icon>
          </v-btn>


          <!--
          
          <v-btn :x-small="$vuetify.breakpoint.xsOnly" :small="!$vuetify.breakpoint.xsOnly" dark class="mr-0 pa-0" height="48px" :color="(currentLanguage == 'en') ? 'white' : 'black'" @click="SetCurrentLanguage('en')" tile>
            <v-avatar size="24" tile>
              <v-img
              :transition="false"
              :eager="false"
              src="https://xpcwa.blob.core.windows.net/assets/UK%20Flag%20Button.png"
              >
              </v-img>
            </v-avatar>
          </v-btn>
          
          <v-btn :x-small="$vuetify.breakpoint.xsOnly" :small="!$vuetify.breakpoint.xsOnly" dark class="mr-0 pa-0" height="48px" :color="(currentLanguage == 'fr') ? 'white' : 'black'" @click="SetCurrentLanguage('fr')" tile>
            <v-avatar size="24" tile>
              <v-img
              :transition="false"
              :eager="false"
              src="https://xpcwa.blob.core.windows.net/assets/French%20Flag%20Button.png"
              >
              </v-img>
            </v-avatar>
          </v-btn>

          -->
      </v-toolbar-items>
      <div v-else>

         <v-btn dark  class="ma-0" :x-large="!$vuetify.breakpoint.smAndDown" height="100%" tile color="transparent" text @click="CloseTour()">
            <span style="color:#69d6e0;" >EXIT TOUR</span>
             <v-icon right color="#69d6e0">
              mdi-close
            </v-icon>
        </v-btn>

      </div>
    </v-toolbar>
    <v-dialog v-model="helpGuideDialog" max-width="500px" style="overflow-y:auto;">
      <v-card dark style="" v-if="currentLanguage == 'en'">
        <v-card-text>
          <v-row align="center" justify="center">
            <v-col cols="9" md="10">
               <span class="title" style="min-height:50px!important;color:white;">
                Navigating around the Museum
              </span>
            </v-col>
            <v-col cols="3" md="2">
              <v-btn text class="ma-0" @click="helpGuideDialog = false">
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                  <v-icon color="white" size="32">
                    mdi-map-marker
                  </v-icon>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Map Menu</span>
              <br/>
              Select and click to go to desired section or artefact
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                  <v-img height="32" width="32" contain src="https://activstoredev.blob.core.windows.net/test/FloorMarkerWhite.png">
                    
                  </v-img>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Floor Navigation</span>
              <br/>
              Click or tap on the floor to move around.
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                   <v-icon color="white" size="32">
                    mdi-cursor-pointer
                  </v-icon>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Mouse or touch pad</span>
              <br/>
              Move to view space around you or spin 3D artefacts.
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                   <v-img height="32" width="32" contain src="https://activstoredev.blob.core.windows.net/test/WA/Insight%20Button.png">
                  </v-img>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Activation points</span>
              <br/>
              Click on pink circles to open content.
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                   <v-img height="32" width="32" contain src="https://xpcwa.blob.core.windows.net/assets/Flags.png">
                  </v-img>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">ENG & FRA & ESP</span>
              <br/>
              Click on button to change language of content.
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                    <v-icon color="white" size="32">
                    mdi-home
                  </v-icon>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Home button</span>
              <br/>
              Returns you to beginning.
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                  <v-img height="32" width="32" contain src="https://xpcwa.blob.core.windows.net/assets/CardIcon.png">
                  </v-img>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Collector’s Card</span>
              <br/>
              Click on this symbol inside the artefact activation panel to order cards.
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card dark style="" v-else-if="currentLanguage == 'es'">
        <v-card-text>
          <v-row align="center" justify="center">
            <v-col cols="9" md="10">
               <span class="title" style="min-height:50px!important;color:white;">
                Navegando por el museo
              </span>
            </v-col>
            <v-col cols="3" md="2">
              <v-btn text class="ma-0" @click="helpGuideDialog = false">
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                  <v-icon color="white" size="32">
                    mdi-map-marker
                  </v-icon>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Menú de mapa</span>
              <br/>
              Selecciona y haz clic para dirigirte a la sección o al artículo de tu elección.
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                  <v-img height="32" width="32" contain src="https://activstoredev.blob.core.windows.net/test/FloorMarkerWhite.png">
                    
                  </v-img>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Navegación de piso</span>
              <br/>
              Haga clic o toque en el suelo para moverse.
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                   <v-icon color="white" size="32">
                    mdi-cursor-pointer
                  </v-icon>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Ratón o panel táctil</span>
              <br/>
              Muévelo para ver el espacio a tu alrededor o para girar los artículos en 3D.
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                   <v-img height="32" width="32" contain src="https://activstoredev.blob.core.windows.net/test/WA/Insight%20Button.png">
                  </v-img>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Puntos de activación</span>
              <br/>
              Haz clic en los círculos de color rosa para abrir el contenido.
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                   <v-img height="32" width="32" contain src="https://xpcwa.blob.core.windows.net/assets/Flags.png">
                  </v-img>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">ENG, FRA, ESP</span>
              <br/>
              Haz clic en el botón para cambiar el idioma del contenido
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                    <v-icon color="white" size="32">
                    mdi-home
                  </v-icon>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Botón de página principal</span>
              <br/>
              Vuelve al principio
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                  <v-img height="32" width="32" contain src="https://xpcwa.blob.core.windows.net/assets/CardIcon.png">
                  </v-img>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Tarjeta de coleccionista</span>
              <br/>
              Haga clic en este símbolo dentro del panel de activación de artefactos para pedir tarjetas.
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card dark style="" v-else-if="currentLanguage == 'fr'">
        <v-card-text>
          <v-row align="center" justify="center">
            <v-col cols="9" md="10">
               <span class="title" style="min-height:50px!important;color:white;">
                Pour se déplacer dans le musée 
              </span>
            </v-col>
            <v-col cols="3" md="2">
              <v-btn text class="ma-0" @click="helpGuideDialog = false">
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                  <v-icon color="white" size="32">
                    mdi-map-marker
                  </v-icon>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Plan du musée</span>
              <br/>
              Sélectionnez cette option et cliquez pour vous rendre à une galerie ou à un l’objet
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                  <v-img height="32" width="32" contain src="https://activstoredev.blob.core.windows.net/test/FloorMarkerWhite.png">
                    
                  </v-img>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Navigation au sol</span>
              <br/>
              Cliquez ou appuyez sur le sol pour vous déplacer.
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                   <v-icon color="white" size="32">
                    mdi-cursor-pointer
                  </v-icon>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Souris ou pavé tactile</span>
              <br/>
              Pour vous déplacer et observer l’espace autour de vous ou faire tourner les objets 3D
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                   <v-img height="32" width="32" contain src="https://activstoredev.blob.core.windows.net/test/WA/Insight%20Button.png">
                  </v-img>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Points d’activation</span>
              <br/>
              Cliquez sur les cercles roses pour accéder au contenu
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                   <v-img height="32" width="32" contain src="https://xpcwa.blob.core.windows.net/assets/Flags.png">
                  </v-img>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">ENG, FRA, ESP</span>
              <br/>
              Cliquez sur le bouton pour changer la langue d’affichage
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                    <v-icon color="white" size="32">
                    mdi-home
                  </v-icon>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Bouton Accueil</span>
              <br/>
              Pour revenir au début de la visite
            </v-col>
            <v-col cols="2" class="pb-1 pt-1">
              <v-row>
                <v-spacer/>
                <v-col cols="auto">
                  <v-img height="32" width="32" contain src="https://xpcwa.blob.core.windows.net/assets/CardIcon.png">
                  </v-img>
                </v-col>
                <v-spacer/>
              </v-row>
            </v-col>
            <v-col cols="10" class="pb-1 pt-1">
              <span class="font-weight-bold subtitle-1">Carte de collection</span>
              <br/>
              Cliquez sur ce symbole à l'intérieur du panneau d'activation de l'artefact pour commander des cartes.
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import { mapState,mapMutations, mapGetters } from 'vuex'


  export default {
    name: 'HeaderBar',
    components: {
    },
    props: {
    },
    computed: {

      ...mapState("sessionState", [
        "package",
        "currentLanguage",
        "navigationBar",
        "activeTour",
        "homeScreenVisibility",
        "isPlayingAudio"
      ]),

      ...mapGetters("sessionState", [
        "CurrentStageData"
      ]),

      iconForLcl()
      {
        var foundLcl = this.languages.find(item => item.key == this.currentLanguage);
        return foundLcl.icon;

      },

      kioskMode ()
      {
        if(this.package != null)
        {
          if(this.package.settings != null)
          {
            if(this.package.settings.kioskMode)
              return true;
          }
        }

        return false;
      }
    },

    mounted () {

      var existingCookie = this.GetCookie("mowafts");

      if(existingCookie != "")
      {
        this.shownHelpGuideOnce = true;
      }

    },
    data: () => ({

      shownHelpGuideOnce : false,
      helpGuideDialog : false,
      selectedLanguage : 0,
      languages : [
        {
          key : "en",
          icon : "https://xpcwa.blob.core.windows.net/assets/UK%20Flag%20Button.png"
        },
        {
          key : "fr",
          icon : "https://xpcwa.blob.core.windows.net/assets/French%20Flag%20Button.png"
        },
        {
          key : "es",
          icon : "https://xpcwa.blob.core.windows.net/assets/Spanish%20Flag.png"
        }
      ]

    }),
    methods: {

      ...mapMutations("sessionState", [
        "SetCurrentLanguage",
        "SetNavigationBar",
         "CloseTour",
         "SetHomeScreenVisibility",
         "SetDesiredWaypoint",
         "PlayAudio",
         "PauseAudio"
      ]),

      OnTapAudio()
      {
        if(this.isPlayingAudio)
        {
          this.PauseAudio();
        }
        else
        {
          this.PlayAudio();
        }
      },

      SetCookie(cname, cvalue) {
        document.cookie = cname + "=" + cvalue;
      },

      GetCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      },

      OnTapHome()
      {
        this.SetDesiredWaypoint(this.CurrentStageData.waypoints[0]);
        this.SetHomeScreenVisibility(true);
        
      }

    },
    watch: {

      homeScreenVisibility : {

        handler(newVal)
        {
          if(!newVal && !this.shownHelpGuideOnce)
          {
            this.helpGuideDialog = true;
           
          }
        }

      },

      helpGuideDialog : {

        handler(newVal)
        {
          if(!newVal)
          {
            if(!this.shownHelpGuideOnce)
            {
              this.shownHelpGuideOnce = true;
               this.SetCookie("mowafts",true);
            }
          }
        }

      }
      
    }
  }
</script>

<style>

.v-toolbar__content{

  padding: 0px!important;

}

</style>
